export default __webpack_public_path__ + "static/media/icon_development_vector.beb09550.svg";